import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-menu",
  "use": "icon-menu-usage",
  "viewBox": "0 0 500 501",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 500 501\" id=\"icon-menu\">\n  <g id=\"icon-menu_Page-1\" fill=\"none\" fill-rule=\"evenodd\" stroke=\"none\" stroke-width=\"1\">\n    <path id=\"icon-menu_Combined-Shape\" fill=\"currentColor\" fill-rule=\"nonzero\" d=\"M351.098485,321 L351.098485,348 L51.9015152,348 L51.9015152,321 L351.098485,321 Z M450.94697,158 L450.94697,185 L52.0530303,185 L52.0530303,158 L450.94697,158 Z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol